export const POPULAR_SEARCHES = [
  'Custom software development',
  'AI Services',
  'Mobile development',
  'Design services',
  'Web development',
  'Maintenance support',
];

export const SEARCH_SUGGESTIONS = [
  'Advanced EHR system',
  'AI chatbot',
  'AI consulting',
  'AI development',
  'AI in healthcare',
  'AI in software testing',
  'AI software development',
  'AI solutions',
  'AI-driven insurance solution',
  'AI-powered imaging solution',
  'Airline payment audit',
  'ALM for automotive systems',
  'Android app development',
  'Angular',
  'Angular development',
  'Animated TV and streaming service design',
  'API testing benefits',
  'App development timeline',
  'Application lifecycle management',
  'Artificial intelligence',
  'Asset management software',
  'Automation testing',
  'Automotive business digitalization',
  'Automotive infotainment testing',
  'AWS cloud solution',
  'AWS development',
  'BA artifacts in software development',
  'Back-end development',
  'Banking document management system',
  'Banking integration software',
  'Banking software',
  'Banking software development',
  'Betting platform development',
  'Blockchain development',
  'BNPL solutions',
  'Business analysis',
  'Business Analysis-as-a-Service',
  'Business intelligence',
  'Business intelligence in supply chains',
  'Car rental digital platform',
  'Clinical data management',
  'Cloud data migration strategy',
  'Cloud file transfer platform',
  'Cloud migration',
  'Cloud solutions',
  'Cloud-based app development',
  'Compliance management',
  'Connected TV growth trends',
  'CPQ software for wellness',
  'CRM system for telecom',
  'Cross-platform development',
  'Cryptocurrency software development',
  'Cryptocurrency wallet development',
  'Custom API integration',
  'Custom CPQ software',
  'Custom enterprise logistics software',
  'Custom software development',
  'Cybersecurity',
  'dApp development',
  'Data analytics',
  'Data lake for advertising',
  'Data science',
  'Database development',
  'Dedicated development team',
  'DeFi lending platform',
  'Design debt prevention',
  'DesignOps for teams',
  'DevOps benefits for businesses',
  'DevOps in finance',
  'DevOps services',
  'Digital banking',
  'Digital banking trends',
  'Digital cockpit software',
  'Digital freight forwarding',
  'Digital health',
  'Digital transformation',
  'Digital transformation in banking',
  'Digital transformation in logistics',
  'Discovery phase',
  'Discovery phase deliverables',
  'Drone management portal',
  'eCommerce development',
  'eCommerce logistics solution',
  'EHR implementation guide',
  'EHR system',
  'EHR/EMR software',
  'Enterprise software',
  'Enterprise website design',
  'eWallet app development',
  'Exploring technology trends in automotive',
  'Features for staff management software',
  'Fintech development',
  'Fintech UI/UX design tips',
  'Fleet management software',
  'Fleet management with IoT',
  'Flutter development',
  'Freight forwarding solutions',
  'Front-end development',
  'Golang development',
  'Graphic design',
  'Health information management',
  'Healthcare compliance',
  'Healthcare software',
  'Healthcare software development',
  'Hire developers',
  'How to build a live streaming app',
  'How to hire fintech developers',
  'Image recognition module',
  'Impact of DevOps on finance',
  'Intelligent diagnostics solutions',
  'Investment app for retail investors',
  'IoT development',
  'IoT in healthcare',
  'IT consulting',
  'IT outsourcing',
  'IT outsourcing in Ukraine',
  'IT security',
  'Java development',
  'JavaScript development',
  'Last-mile delivery challenges',
  'Legacy system modernization',
  'LIMS development services',
  'Loan lending app development',
  'Logistics tracking software',
  'Logistics management software',
  'Logistics software',
  'Machine learning',
  'Managed IT services',
  'Marketing software',
  'Medical software',
  'Mental health app development',
  'Mobile app development',
  'Mobile banking research',
  'Mobile design',
  'MVP development',
  'MVP development guide',
  'NFT development',
  'Node.js development',
  'Open banking',
  'Order fulfillment steps',
  'Order management software',
  'Outsourced software testing',
  'PACS/DICOM software',
  'Patient engagement platform',
  'Payment clearing solution',
  'Payment solutions',
  'Penetration testing',
  'Personalized banking software',
  'Pharma software development',
  'PHP development',
  'Predictive analytics for eCommerce',
  'Price comparison software',
  'Progressive web apps',
  'Project discovery phase',
  'Project management',
  'Python development',
  'QA services',
  'React development',
  'React Native development',
  'Remote patient monitoring',
  'Robotic process automation in insurance',
  'Ruby on Rails benefits',
  'Ruby on Rails development',
  'Rust development',
  'Salesforce implementation',
  'Scala development',
  'Scalability solutions',
  'SD-WAN security',
  'Security operations center',
  'Smart contracts',
  'Software architecture',
  'Software testing trends',
  'Software-defined vehicles',
  'Sports betting software',
  'Staff augmentation',
  'Staff management software',
  'Supply chain business: overview',
  'Supply chain software',
  'Telemedicine development',
  'Telemedicine software',
  'Test automation frameworks',
  'Testing services',
  'Trading software',
  'Transportation industry digital transformation',
  'UI/UX design',
  'UI/UX design for fintech',
  'UI/UX redesign for airline SaaS',
  'Warehouse management',
  'Warehouse management system',
  'Wearable technology in healthcare',
  'Web design',
  'Web development',
  'Web portal development',
  'Workflow automation',
];
